export default "__VITE_ASSET__bb40523a__"